import react from "react";
import KpiCard from "../../../Component/RetUserComponents/KpiCard";
import { AlertTriangle, CheckCircle2, FileText, ShieldCheck } from "lucide-react";
import SectionCard from "../../../Component/RetUserComponents/SectionCard";
import Badge from "../../../Component/RetUserComponents/Badge";
import { useNavigate } from "react-router-dom";

export default function OverviewView({ warrantyStats, lastWarranty }) {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KpiCard
          label="My Warranties"
          value={warrantyStats.total}
          subLabel="Total registered by you"
          icon={ShieldCheck}
          onClick={() => navigate("/userwarnty", { state: { fromKPI: true } })}
        />

        <KpiCard
          label="Approved"
          value={warrantyStats.approved}
          subLabel="Approved by admin"
          icon={CheckCircle2}
          onClick={() =>
            navigate("/userwarnty", { state: { statusFilter: "Approved", fromKPI: true } })
          }
        />
        <KpiCard
          label="Pending"
          value={warrantyStats.pending}
          subLabel="Waiting for approval"
          icon={AlertTriangle}
          onClick={() =>
            navigate("/userwarnty", { state: { statusFilter: "Pending", fromKPI: true } })
          }
        />
        <KpiCard
          label="Rejected"
          value={warrantyStats.rejected}
          subLabel="Rejected by admin"
          icon={FileText}
          onClick={() =>
            navigate("/userwarnty", { state: { statusFilter: "Rejected", fromKPI: true } })
          }
        />
      </div>

      <SectionCard title="Last Warranty Registered">
        {lastWarranty ? (
          <div className="text-xs space-y-2">
            <div className="flex flex-wrap justify-between gap-2">
              <div>
                <div className="font-semibold text-slate-800">
                  {lastWarranty.productName}
                </div>
                <div className="text-[11px] text-slate-500">
                  Invoice: {lastWarranty.invoiceNo} · IMEI: {lastWarranty.imei}
                </div>
              </div>
              <div className="text-right">
                <div className="text-[11px] text-slate-500">Registered On</div>
                <div className="font-medium text-slate-800">
                  {lastWarranty.registeredOn}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <span className="text-[11px] text-slate-500">Status: </span>
              <Badge
                color={
                  lastWarranty.status === "Approved"
                    ? "green"
                    : lastWarranty.status === "Rejected"
                    ? "red"
                    : "yellow"
                }
              >
                {lastWarranty.status}
              </Badge>
            </div>

            <div>
              <div className="text-[11px] text-slate-500">Issue:</div>
              <div className="text-xs text-slate-700">
                {lastWarranty.issueType}
              </div>
            </div>

            <div>
              <div className="text-[11px] text-slate-500">Registered By:</div>
              <div className="text-xs text-slate-800 font-medium">
                {lastWarranty.registeredBy}
              </div>
            </div>

            {lastWarranty.status === "Rejected" &&
              lastWarranty.adminRejectReason && (
                <div className="border border-rose-100 bg-rose-50 rounded-xl p-2">
                  <div className="text-[11px] font-semibold text-rose-700 flex items-center gap-1">
                    <AlertTriangle className="w-3 h-3" />
                    <span>Reject Reason from Admin</span>
                  </div>
                  <div className="text-[11px] text-rose-700 mt-1">
                    {lastWarranty.adminRejectReason}
                  </div>
                </div>
              )}
          </div>
        ) : (
          <div className="text-xs text-slate-500">
            You haven&apos;t registered any warranties yet. Use the
            <span className="font-semibold"> Add Warranty </span>
            form to start.
          </div>
        )}
      </SectionCard>
    </div>
  );
}